import React, {useCallback, useState} from "react"
import Alert from "@amzn/meridian/alert";
import Toaster from "@amzn/meridian/toaster";

/**
 * This component will render App notification messages
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AppNotification = (props) => {
    let alertType = props.type ? props.type : "informational";

    const [toasts, setToasts] = useState(props.message ? [{
        id: Date.now().toString()
    }] : []);


    const onCloseToast = useCallback(
        id => setToasts(toasts.filter(t => t.id !== id)),
        [toasts]);

    return (
        <React.Fragment>
            <Toaster toasts={toasts} onCloseToast={onCloseToast}>
                {toast => <Alert type={alertType} toast={true} onClose={toast.onClose}>{props.message}</Alert>}
            </Toaster>
        </React.Fragment>
    )
}

export default AppNotification;


// WEBPACK FOOTER //
// ./src/component/common/appNotification.js